import * as params from '../util/params'

import * as util from '../util/util'

import * as ws_base from '../ws/ws_base'


const DOMINIO = "propostas";


export async function buscarPropostas(id_pedido, id_usuario){

	return await ws_base.post(DOMINIO, "obter", {"id_pedido": id_pedido, "id_usuario": id_usuario});
}


export async function buscarProposta(id_proposta){

	return util.primeiroOuNada(await ws_base.get(DOMINIO, "obter", {"id": id_proposta}));
}


export async function novaProposta(dados){

	return await ws_base.post(DOMINIO, "novo", dados);
}
  
  
export async function novoItemProposta(item){

	return await ws_base.post(DOMINIO, "novo_item", item);													
}


export async function excluirProposta(id_proposta){
	
	return await ws_base.get(DOMINIO, "remover", {"id_proposta": id_proposta});
}


export async function alterarProposta(id_proposta, descricao, valor){

	return await ws_base.post(DOMINIO, "alterar", {"id_proposta": id_proposta,
														"valor": valor, 
															"descricao": descricao});
}


export async function excluirItensProposta(id_proposta){
	
	return await ws_base.get(DOMINIO, "remover_itens", {"id_proposta": id_proposta});
}